import * as React from 'react';

import {DefaultReportCard} from 'shells/default-report-card/default-report-card';
import {FeatureCardGrid} from 'shells/grid-list/feature-card-grid';

import {appHistory} from '../../../../history';

import type {DefaultReport} from './types';

type Props = {
    reports: DefaultReport[];
    illustrationPosition?: 'left' | 'right';
};

export function DefaultReportsGrid(props: Props) {
    const {illustrationPosition = 'left'} = props;

    const renderCard = React.useCallback((report: DefaultReport) => {
        return (
            <DefaultReportCard
                key={report.type}
                title={report.name}
                description={report.description}
                thumbnailIllustration={report.illustration}
                reportType={report.type}
                history={appHistory}
                exploreLink={report.url}
                cta={report.cta}
            />
        );
    }, []);

    const hasIllustration = React.useCallback((report: DefaultReport) => {
        return Boolean(report.illustration);
    }, []);

    const getKey = React.useCallback((report: DefaultReport) => {
        return report.type;
    }, []);

    return (
        <FeatureCardGrid
            items={props.reports}
            renderCard={renderCard}
            hasIllustration={hasIllustration}
            getKey={getKey}
            numColumns={3}
            illustrationPosition={illustrationPosition}
        />
    );
}
